import { connect } from 'react-redux';
import { shouldLoadFullStory } from '../../../config/ab/selector';
import { isBookingStateForPrivateWhiteLabel } from '../../../utils/isPrivateWhiteLabel';
import FullStory from './FullStory';

export const mapStateToProps = (state) => ({
    shouldLoadFullStory:
        shouldLoadFullStory(state) &&
        !isBookingStateForPrivateWhiteLabel(state),
});

export default connect(mapStateToProps)(FullStory);
